import { authApi } from "@/api/services";
import { setAccessToken, setRefreshToken } from "@/api/client";

/**
 * Switch the active organization: POST /auth/switch-organization (membership-
 * verified server-side), swap the stored tokens for the fresh org-scoped
 * session, then do a full load of `to` so every query, store and route context
 * re-initializes for the new org — no re-login.
 *
 * The one switch path: the org switcher (to "/") and the cross-org project gate
 * (to the same project URL, row 2b6d6836) both call it. Throws on a failed
 * switch so the caller can stay put.
 */
export async function switchActiveOrg(orgId: string, to: string = "/"): Promise<void> {
  const res = await authApi.switchOrganization(orgId);
  setAccessToken(res.access_token);
  if (res.refresh_token) setRefreshToken(res.refresh_token);
  window.location.assign(to);
}
